import { render, staticRenderFns } from "./AlertLinks.vue?vue&type=template&id=133a9fda"
import script from "./AlertLinks.vue?vue&type=script&lang=js"
export * from "./AlertLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports